import React, {useEffect, useState} from 'react';

import {IMG_DIR} from '#Client/components/constants';
import {Modal} from '#Client/components/Modal/Modal';
import {
  orderCell,
  orderHeader,
  orderRow,
  orderTable,
  orderTitle,
  productDescription,
  tableWrapper,
  totalLabel,
} from '#Client/components/OrderModal/OrderModal.css';
import {getOrder, GetOrderResponse} from '#Common/api/api';
import {toDollars} from '#Common/util';

type OrderModalProps = {
  orderPaymentIntentClientSecret: string;
  onClose: () => void;
};

export const OrderModal = ({
  orderPaymentIntentClientSecret,
  onClose,
}: OrderModalProps) => {
  const [inFlight, setIsInFlight] = useState<boolean>(true);
  const [order, setOrder] = useState<GetOrderResponse | undefined>(undefined);
  useEffect(() => {
    (async () => {
      const fetchedOrder = await getOrder(orderPaymentIntentClientSecret);
      setIsInFlight(false);
      setOrder(fetchedOrder);
    })();
  }, []);

  return (
    <Modal
      image={`${IMG_DIR}icon_scroll.png`}
      title="Your Order"
      onClose={onClose}
    >
      {inFlight ? (
        'Loading...'
      ) : order ? (
        <>
          <h2 className={orderTitle}>Thank you for your order</h2>
          <div className={tableWrapper}>
            <div className={orderHeader}>
              <div>
                Order Key: {order.orderKey.substring(0, 8)}-{order.orderId}
              </div>
              <div>
                Order Date:{' '}
                {new Date(order.createdAt).toLocaleString('en-us', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                })}
              </div>
            </div>
            <h3 className={orderTitle}>Your items</h3>
            <table className={orderTable}>
              <tbody>
                {order.products.map(({id, name, description, price}) => (
                  <tr className={orderRow} key={id}>
                    <td className={orderCell}>
                      <strong>{name}</strong>
                    </td>
                    <td className={`${orderCell} ${productDescription}`}>
                      <div>{description}</div>
                    </td>
                    <td className={orderCell}>
                      <div>{toDollars(price)}</div>
                    </td>
                  </tr>
                ))}
                <tr className={orderRow}>
                  <td className={`${orderCell} ${totalLabel}`} colSpan={2}>
                    <strong>Total</strong>
                  </td>
                  <td className={orderCell}>
                    <strong>{toDollars(order.amount)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </Modal>
  );
};
